export type Deliverable = {
  title: string
  highlight: string
  tag: string
  detail: string
  image: string
  alt: string
}

export const deliverables: Deliverable[] = [
  {
    tag: 'Recetario 1',
    title: '100 Recetas',
    highlight: 'para hacer en casa',
    detail:
      'Fáciles, económicas y de todos los días: tortillas, guisos, tartas, pastas y postres para resolver cualquier comida.',
    image:
      'https://cdn.magicpatterns.com/uploads/i3SV2cm4FQyT2eUyUy3Cer/ChatGPT_Image_12_ago_2026,_07_49_45_p.m._(2).png',
    alt: 'Póster con 100 recetas fáciles y económicas para hacer en casa',
  },
  {
    tag: 'Recetario 2',
    title: '100 Recetas',
    highlight: 'para viandas al cole',
    detail:
      'Viandas saludables y prácticas que los chicos sí terminan: wraps, tortillas, budines, mini pizzas y frutas.',
    image:
      'https://cdn.magicpatterns.com/uploads/1n2uGnWbZzA8rgVajq9P7g/ChatGPT_Image_12_ago_2026,_07_49_56_p.m..png',
    alt: 'Póster con 100 recetas de viandas para llevar al cole',
  },
  {
    tag: 'Recetario 3',
    title: '100 Recetas',
    highlight: 'para llevar al trabajo',
    detail:
      'Almuerzos que viajan bien y se comen fríos o al microondas: bowls, ensaladas completas, wraps y termos.',
    image:
      'https://cdn.magicpatterns.com/uploads/kvAwDV5SgKjqBdBEFBCKGY/ChatGPT_Image_12_ago_2026,_07_49_54_p.m..png',
    alt: 'Póster con 100 recetas prácticas para llevar al trabajo',
  },
  {
    tag: 'Recetario 4',
    title: '100 Recetas',
    highlight: 'para la merienda con amiguitos',
    detail:
      'Dulces y salados para compartir: brownies, budines, scones, alfajores y bocaditos listos para transportar.',
    image:
      'https://cdn.magicpatterns.com/uploads/wMCj4uod9LqrezJaePwH2R/ChatGPT_Image_12_ago_2026,_07_49_49_p.m..png',
    alt: 'Póster con 100 recetas para llevar a merendar a la casa de los amiguitos',
  },
]
